<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="dashboardAdmin-parentdiv bluebtn">
      <div class="dashboardAdmin-header mt-4">
        <div class="dashboardAdmin-header-main-head d-flex">
          <img
            src="../../assets/New-imgs/interviewProcess-icons/newInt-backBtn-arrow.svg"
            alt=""
            class="mr-3 pointer"
            @click="gobackDashboard"
          />

          <span>
            {{
              $route.name === "EditInterviewProcess"
                ? "Edit"
                : $route.name === "ActivateInterview"
                ? "Activate"
                : "Create"
            }}
            Interview Process
          </span>
        </div>
      </div>

      <div
        class="mt-3 teams-main-container p-0"
        style="height: calc(100vh - 174px)"
      >
        <div class="h-100 w-100">
          <div
            style="
              height: 90%;
              overflow-x: hidden;
              overflow-y: auto;
              padding: 30px;
            "
            class="d-flex w-100"
          >
            <div style="width: 40%" class="pr-3">
              <div>
                <div class="topDiv w-100">
                  <InputField
                    :type="'text'"
                    :label="'Interview Process Name'"
                    :mandatory="true"
                    :placeholder="'Enter'"
                    :id="'interviewprocess'"
                    :value="JobTitles"
                    :vmodel="JobTitles"
                    :showError="$v.JobTitles.$error"
                    @select-value="updateField($event, 'JobTitles')"
                  />

                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="$v.JobTitles.$dirty && !$v.JobTitles.required"
                  >
                    Required
                  </div>
                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="!$v.JobTitles.maxLength && $v.JobTitles.required"
                  >
                    Should not exceed 128 characters
                  </div>
                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="!$v.JobTitles.alpha && $v.JobTitles.required"
                  >
                    Please enter a valid title
                  </div>
                </div>
              </div>
              <hr class="mt-4" />
              <div class="d-flex w-100">
                <div class="topDiv w-50 mr-3 mt-1">
                  <InputField
                    :disabled="tabs.length == 10 && !editround"
                    :type="'text'"
                    :label="'Round Name'"
                    :placeholder="'Enter'"
                    :id="'interviewprocess'"
                    :value="selectedRound.name"
                    :vmodel="selectedRound.name"
                    :showError="
                      $v.selectedRound.name.$error ||
                      (errorSameName && selectedRound.name != '')
                    "
                    @select-value="updateField($event, 'selectedRoundName')"
                  />
                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="
                      $v.selectedRound.name.$dirty &&
                      !$v.selectedRound.name.required
                    "
                  >
                    Required
                  </div>
                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="selectedRound.name != '' && errorSameName"
                  >
                    Round name already exists
                  </div>
                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="
                      !$v.selectedRound.name.maxLength &&
                      $v.selectedRound.name.required
                    "
                  >
                    Should not exceed 128 characters
                  </div>
                  <div
                    class="newInt-required-validation-font mt-1"
                    v-if="
                      !$v.selectedRound.name.alpha &&
                      $v.selectedRound.name.required
                    "
                  >
                    Please Enter a Valid Name
                  </div>
                </div>
                <div class="topDiv w-50">
                  <label class="teams-label-font"> Round Type</label>
                  <div>
                    <Select
                      :disableDropdown="tabs.length == 10 && !editround"
                      :type="'filter'"
                      :dropdownOptions="roundtype"
                      :placeholder="'Select'"
                      :value="selectedRound.type"
                      @setValue="selectedRound.type = $event"
                      :showError="$v.selectedRound.type.$error"
                      id="interview"
                    />
                  </div>
                </div>
              </div>
              <div
                class="ip-more-rounds mt-2"
                v-if="tabs.length == 10 && !editround"
              >
                <img
                  src="../../assets/New-imgs/interviewProcess-icons/ip-more-rounds.svg"
                  alt=""
                />
                <span class="ml-2 mt-1">
                  Number of rounds cannot be more than 10
                </span>
              </div>
              <div
                class="mt-4 d-flex align-items-center"
                :class="
                  editround ? 'justify-content-between' : 'justify-content-end'
                "
              >
                <div
                  class="pointer pff-btn-txt"
                  v-if="editround"
                  @click="resetSelectedRound()"
                >
                  Cancel
                </div>
                <div class="d-flex align-items-center">
                  <div
                    class="pointer"
                    :class="{
                      'pff-btn-disable-btntxt':
                        selectedRound.type == null ||
                        selectedRound.name == '' ||
                        (!discardProcess && editround),
                      'pff-btn-txt':
                        (selectedRound.type != null &&
                          selectedRound.name != '' &&
                          !editround) ||
                        discardProcess,
                    }"
                    @click="
                      selectedRound.type != null && selectedRound.name != ''
                        ? editOrUpdateOrDeleteRound('discard', '')
                        : ''
                    "
                  >
                    Discard
                  </div>
                  <div class="pff-btn-divider mx-3"></div>
                  <div
                    :class="{
                      'pff-btn-disable-btntxt':
                        selectedRound.name == '' ||
                        selectedRound.type == null ||
                        errorSameName ||
                        (tabs.length == 10 && !editround),
                      'pff-btn-txt':
                        selectedRound.name != '' &&
                        selectedRound.type != null &&
                        !errorSameName,
                    }"
                    class="pff-btn-txt pointer"
                    @click="handleRoundAction"
                  >
                    {{ !editround ? "Add" : "Update" }}
                  </div>
                </div>
              </div>
            </div>
            <div
              style="width: 60%"
              class="newInt-rightSideContent"
              id="scrollTobottom"
            >
              <div v-if="shimmerLoader">
                <b-skeleton class="w-35"></b-skeleton>
              </div>
              <div class="pff-right-heading" v-else>
                Interview Process
                <img
                  v-if="
                    aiLength !== 0 &&
                    $route.name == 'CreateInterviewProcess' &&
                    !aiEditRound
                  "
                  src="../../assets/New-imgs/interviewProcess-icons/ai-button.svg"
                  alt=""
                />
              </div>
              <draggable :list="tabs">
                <div class="interview-process-card w-90" v-if="shimmerLoader">
                  <b-card class="mt-2" v-for="i in loop" :key="i">
                    <b-skeleton class="w-75"></b-skeleton>
                  </b-card>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center w-100 mt-3"
                  v-for="(int, index) in tabs"
                  :key="int.id"
                >
                  <div class="pointer">
                    <img
                      src="../../assets/img/feedbackform/drag-and-drop.svg"
                      alt=""
                    />
                  </div>
                  <div
                    :class="
                      !tabs[index].roundIndex
                        ? 'interview-process-card'
                        : 'interview-process-card-selected'
                    "
                    class="w-90 ml-3"
                  >
                    <b-card>
                      <div
                        class="
                          d-flex
                          w-100
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div class="d-flex align-items-center w-50">
                          <div>
                            <img
                              v-if="int.type == 'assesment'"
                              src="../../assets/New-imgs/interviewProcess-icons/new-int-asses.svg"
                            />
                            <img
                              v-else
                              src="../../assets/New-imgs/interviewProcess-icons/new-int-f2f.svg"
                            />
                          </div>

                          <div
                            class="
                              mt-1
                              ml-2
                              interview-process-round-text
                              text-truncate
                              w-100
                            "
                          >
                            <span
                              class="text-truncate d-inline-block"
                              style="min-width: auto; max-width: 100%"
                            >
                              {{ int.name }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-end
                            w-50
                          "
                        >
                          <div
                            class="common-sm-blue-box mr-3"
                            :class="
                              tabs[index].roundIndex
                                ? 'interview-process-edit-card'
                                : ''
                            "
                          >
                            {{
                              int.type == "assesment"
                                ? "Assessment"
                                : "Face to Face"
                            }}
                          </div>
                          <div>
                            <img
                              @click="
                                !tabs[index].roundIndex
                                  ? editOrUpdateOrDeleteRound('edit', int)
                                  : ''
                              "
                              v-b-tooltip.hover.top="
                                !tabs[index].roundIndex ? 'Edit' : ''
                              "
                              :class="
                                !tabs[index].roundIndex
                                  ? 'pointer'
                                  : 'ip-opacity'
                              "
                              class="mr-2"
                              src="../../assets/img/newworkbench/internalhiring/edit.svg"
                              alt=""
                            />
                            <img
                              @click="
                                !tabs[index].roundIndex && tabs.length > 1
                                  ? editOrUpdateOrDeleteRound('delete', index)
                                  : ''
                              "
                              v-b-tooltip.hover.top="
                                !tabs[index].roundIndex && tabs.length > 1
                                  ? 'Delete'
                                  : ''
                              "
                              :class="
                                tabs[index].roundIndex || tabs.length === 1
                                  ? 'ip-opacity'
                                  : 'pointer'
                              "
                              src="../../assets/img/newworkbench/internalhiring/delete.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div
            style="height: 10%"
            class="
              newInt-footer
              d-flex
              align-items-center
              justify-content-end
              w-100
              bluebtn
            "
          >
            <b-button
              class="acs-cancelBtn-modal mr-3"
              @click="(discardRound = false), gobackDashboard()"
              >Cancel</b-button
            >
            <b-button
              class="acs-addBtn-modal mr-3"
              @click="(discardRound = false), submitForm()"
            >
              {{
                $route.name === "EditInterviewProcess"
                  ? "Update"
                  : $route.name === "ActivateInterview"
                  ? "Activate"
                  : "Save"
              }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <ConfirmModal
      @confirmButton="confirmButton"
      @handle-submit="addInterviewProcess"
      :button="button"
      :header="mobheader"
      :msg="msg"
      :imageSrc="require('../../assets/img/feedbackform/confirmIcon.svg')"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Select from "../../components/fixedcomponents/Select.vue";

import InputField from "../../components/InputComponents/Input";

import {
  required,
  maxLength,
  helpers,
  requiredIf,
} from "vuelidate/lib/validators";
import {
  putintprocess,
  addintprocess,
  getperticularintprocess,
  getAiSuggestionsForInterview,
} from "../../utils/apiFunctions.js";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";

import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
  name: "CreateInterviewProcess",
  mixins: [toast],
  components: {
    Spinner,
    ConfirmModal,
    Select,
    InputField,
    draggable,
  },

  data() {
    return {
      aiLength: null,
      aiEditRound: false,
      shimmerLoader: false,
      loop: 8,
      discardRound: false,
      singleRound: {},
      previousRounds: {
        id: null,
        name: "",
        type: null,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        testID: [],
      },
      editIndex: null,
      editround: false,
      mobheader: "",
      button: "",
      msg: "",
      LoaderStatus: false,
      tabs: [
        {
          id: 1,
          name: "",
          type: null,
          feedbackform: {
            name: "",
            feedbackFormID: "",
          },
          duration: "",
          randomizeTest: false,
          roundIndex: false,
          testID: [],
        },
      ],
      JobTitles: "",
      selectedRound: {
        id: null,
        name: "",
        type: null,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        testID: [],
      },
      originalTabs: [],
      originalName: "",
      roundtype: [
        {
          value: "assesment",
          text: "Assessment",
        },
        {
          value: "f2f",
          text: "Face To Face",
        },
      ],
    };
  },
  validations() {
    return {
      JobTitles: {
        required,
        maxLength: maxLength(128),
        alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
      },
      selectedRound: {
        name: {
          required: requiredIf(function () {
            return this.tabs.length == 0;
          }),
          maxLength: maxLength(128),
          alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
        },
        type: {
          required: requiredIf(function () {
            return this.tabs.length == 0;
          }),
        },
      },
    };
  },
  computed: {
    discardProcess() {
      return (
        this.selectedRound.name != this.previousRounds.name ||
        this.selectedRound.type != this.previousRounds.type
      );
    },
    errorSameName() {
      const roundname = this.selectedRound?.name?.toLowerCase();
      for (const i of this.tabs) {
        const name = i.name.toLowerCase();

        if (
          (!this.editround && roundname === name) ||
          (this.editround && i.id !== this.editIndex && roundname === name)
        ) {
          return true;
        }
      }
      return false;
    },

    hasChanges() {
      if (this.selectedRound.name != "" || this.selectedRound.type != null)
        return true;
      if (this.JobTitles != this.originalName) return true;
      if (this.tabs.length != this.originalTabs.length) return true;
      for (let i = 0; i < this.originalTabs.length; i++) {
        const originalItem = this.originalTabs[i];
        const tabItem = this.tabs[i];

        if (
          originalItem.name !== tabItem.name ||
          originalItem.type !== tabItem.type
        ) {
          return true;
        }
      }
      return false;
    },
    isFromJD() {
      return this.$route.query.redirectTo;
    },
  },

  async created() {
    try {
      if (this.$route.name == "CreateInterviewProcess") {
        this.shimmerLoader = true;

        await this.getAiSuggestions();
      } else {
        await this.getEditIntdata();
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      this.shimmerLoader = false;
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    if (sessionStorage.getItem("isReloading") === "true") {
      sessionStorage.removeItem("isReloading");

      const redirectTo = this.$route.query.redirectTo;
      if (redirectTo) {
        this.goToJd();
      } else {
        this.$router.go(-1);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollContainer = document.getElementById("scrollTobottom");

        scrollContainer.scrollBy({
          top: 5000,
          behavior: "smooth",
        });
      });
    },
    async getAiSuggestions() {
      this.JobTitles = this.$route.query.name;
      try {
        let payload = {
          interviewProcessName: this.$route.query.name,
          count: this.$route.query.count,
        };
        const res = await getAiSuggestionsForInterview(payload);
        if (res.status == 200) {
          this.aiLength = res.data.data.length;
          if (this.aiLength != 0) {
            this.tabs = res.data.data;
            this.shimmerLoader = false;
          } else {
            for (let i = 0; i < this.$route.query.count; i++) {
              const roundName = `Round ${i + 1}`;

              this.tabs.push({
                id: this.tabs.length + 1,
                name: roundName,
                type: "assesment",
                feedbackform: {
                  name: "",
                  feedbackFormID: "",
                },

                duration: "",
                randomizeTest: false,
                roundIndex: false,

                testID: [],
              });
            }
            this.shimmerLoader = false;
          }
        } else {
          this.shimmerLoader = false;
        }
      } catch (error) {
        console.error("Error in getAiSuggestions:", error);
        this.shimmerLoader = false;
      }
    },
    confirmButton(value) {
      this.discardRound = value;
    },
    handleRoundAction() {
      if (
        this.selectedRound.name === "" ||
        this.selectedRound.type === null ||
        this.errorSameName
      ) {
        return;
      }
      if (!this.editround) {
        this.addNewRound();
      } else {
        this.editOrUpdateOrDeleteRound("update", this.singleRound);
      }
    },
    handleBeforeUnload(event) {
      sessionStorage.setItem("isReloading", "true");

      const message = "Changes you made may not be saved.";

      event.returnValue = message;
    },
    async getEditIntdata() {
      this.tabs.forEach((int) => {
        if (int.id === this.editIndex) {
          int.roundIndex = false;
        }
      });

      this.LoaderStatus = true;
      try {
        const { interviewProcessID } = this.$route.params;
        const res = await getperticularintprocess(interviewProcessID);

        if (res?.status === 200) {
          const process = res.data?.data?.process || [];
          const slicedProcess = process.slice(1, process.length - 4);

          this.JobTitles = res.data.data.name;
          this.originalName = this.JobTitles;

          this.tabs = JSON.parse(JSON.stringify(slicedProcess));
          this.originalTabs = slicedProcess;
        } else {
          console.error(`Unexpected response status: ${res.status}`);
        }
      } catch (error) {
        console.error(`Failed to fetch interview process: ${error.message}`);
      } finally {
        this.LoaderStatus = false;
      }
    },

    editOrUpdateOrDeleteRound(action, int) {
      if (action === "edit") {
        // this.aiEditRound = false;
        this.tabs.forEach((i) => {
          if (i.id !== int.id) {
            i.roundIndex = false;
          }
        });
        int.roundIndex = true;

        this.editIndex = int.id;
        this.singleRound = int;
        this.selectedRound.name = int.name;
        this.selectedRound.type = int.type;
        this.editround = true;
        this.previousRounds = { ...this.selectedRound };
      } else if (action === "update") {
        const roundId = this.tabs.findIndex(
          (s) => s.id === this.singleRound.id
        );

        if (roundId !== -1) {
          this.tabs[roundId] = {
            ...this.tabs[roundId],
            name: this.selectedRound.name,
            type: this.selectedRound.type,
          };
        }
        const hasChanges =
          this.selectedRound.name !== this.previousRounds.name ||
          this.selectedRound.type !== this.previousRounds.type;
        if (hasChanges && this.aiLength != 0) {
          this.aiEditRound = true;
        }

        this.singleRound.roundIndex = false;

        this.resetSelectedRound();
      } else if (action === "discard") {
        this.aiEditRound = false;
        if (this.editround) {
          this.selectedRound = { ...this.previousRounds };
        } else {
          this.resetSelectedRound();
        }
      } else if (action === "delete") {
        this.tabs.splice(int, 1);
        this.aiEditRound = true;
      }
    },

    resetSelectedRound() {
      this.selectedRound = {
        id: null,
        name: "",
        type: null,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        testID: [],
      };
      this.editround = false;
      this.tabs.forEach((int) => {
        if (int.id === this.editIndex) {
          int.roundIndex = false;
        }
      });
    },
    getInterviewData() {
      this.getAiSuggestions();
      this.tabs = [];
      this.JobTitles = this.$route.query.name;
      for (let i = 0; i < this.$route.query.count; i++) {
        const roundName = `Round ${i + 1}`;

        this.tabs.push({
          id: this.tabs.length + 1,
          name: roundName,
          type: "assesment",
          feedbackform: {
            name: "",
            feedbackFormID: "",
          },

          duration: "",
          randomizeTest: false,
          roundIndex: false,

          testID: [],
        });
      }
    },
    addNewRound() {
      const newId = this.tabs.length
        ? Math.max(...this.tabs.map((t) => t.id)) + 1
        : 1;
      this.tabs.push({
        id: newId,
        name: this.selectedRound.name,
        type: this.selectedRound.type,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        roundIndex: false,
        testID: [],
      });
      this.aiEditRound = true;
      this.resetSelectedRound();
      this.scrollToBottom();
    },

    updateField(val, fieldName) {
      if (fieldName === "JobTitles") {
        this.JobTitles = val;
        if (this.JobTitles === "") {
          this.$v.JobTitles.$touch();
        }
      } else if (fieldName === "selectedRoundName") {
        this.selectedRound.name = val;
        if (this.selectedRound.name == "") {
          this.$v.selectedRound.name.$touch();
        }
      }
    },
    goToJd(processID) {
      const { wtype, wsort, itype, isort, pageType, customerName } =
        this.$route.query;
      this.$router.push({
        name: this.$route.query.redirectTo,
        query: {
          to: "interview",
          type: pageType,
          wsort,
          wtype,
          itype,
          isort,
          customerName,
          ...(processID ? { process: processID } : {}),
          ...(this.$route.query.jobID
            ? { jobID: this.$route.query.jobID }
            : {}),
        },
      });
    },

    async submitForm() {
      this.$v.$touch();
      if (
        !this.$v.JobTitles.maxLength ||
        !this.$v.selectedRound.name.maxLength
      ) {
        this.errorModal("Should not exceed 128 characters");
        return;
      }

      if (this.errorSameName) {
        this.errorModal("Skill Name already exists");
        return;
      }

      if (this.JobTitles.name !== "" && this.tabs.length > 0) {
        if (!this.$v.$invalid && !this.errorSameName) {
          this.$v.$reset();
          if (
            this.selectedRound.name != "" ||
            this.selectedRound.type != null ||
            (this.selectedRound.name == "" && this.editround)
          ) {
            this.button = "Continue";
            this.msg = "";
            this.mobheader =
              "You have some unsaved changes, Do you like to continue without saving ?";
            this.$bvModal.show("confirmationmsg");
          } else {
            this.addInterviewProcess();
          }
        }
      }
    },

    async addInterviewProcess() {
      if (!this.discardRound && !this.$v.$invalid) {
        try {
          this.tabs = this.tabs.map((tab, index) => {
            tab.id = index + 1;
            return tab;
          });
          let payload = {
            name: this.JobTitles,
            numberOfRounds: this.tabs.length,
            aiEditRound: this.aiEditRound,
            process: this.tabs.map((tab) => {
              tab.feedbackFormID = null;
              delete tab.roundIndex;
              if (tab.type === "f2f") {
                tab.startDate = "";
                tab.endDate = "";
              } else {
                tab.openTestdt = "";
                tab.closeTestdt = "";
              }
              return tab;
            }),
          };
          if (this.$route.name != "CreateInterviewProcess") {
            payload.interviewProcessID = this.$route.params.interviewProcessID;
          }
          let response = {};
          if (this.$route.name == "CreateInterviewProcess") {
            response = await addintprocess(payload);
          } else {
            response = await putintprocess(payload);
          }
          if (response.status == 200) {
            if (this.$route.name === "CreateInterviewProcess") {
              this.successModal("Interview process added successfully!");
            } else if (this.$route.name === "EditInterviewProcess") {
              this.successModal("Interview process updated successfully!");
            } else if (this.$route.name === "ActivateInterview") {
              this.successModal("Interview process activated successfully!");
            }
            if (this.isFromJD) {
              this.goToJd(response.data.data.interviewProcessID);
            } else {
              this.goback();
            }

            this.resetSelectedRound();
          } else if (response.status == 409) {
            this.errorModal("Interview process already exists with same name");
          } else {
            this.errorModal("something went wrong");
          }
        } catch (error) {
          throw new Error(`Failed! Adding Interview Process:${error.status}`);
        }
      } else {
        this.goback();
      }
    },
    gobackDashboard() {
      if (
        ((this.JobTitles != "" ||
          this.selectedRound.name != "" ||
          this.selectedRound.type != null) &&
          this.$route.name == "CreateInterviewProcess") ||
        ((this.$route.name == "EditInterviewProcess" ||
          this.$route.name == "ActivateInterview") &&
          this.hasChanges)
      ) {
        this.mobheader = "Discard Changes";
        this.button = "Discard";
        this.msg = "Are you sure you want to discard the data you entered?";
        this.$bvModal.show("confirmationmsg");
      } else {
        if (this.isFromJD) {
          this.goToJd();
        } else {
          this.goback();
        }
      }
    },
    goback() {
      if (this.isFromJD) {
        this.goToJd();
      } else {
        this.$router.push({
          name: "HiringProcessDashboard",
          query: {
            type: this.$route.query.type,
            sort: this.$route.query.sort,
            status: "interviewProcess",
          },
        });
      }
    },
  },
};
</script>

<style>
.ip-opacity {
  opacity: 0.5;
}
.feedback-left-container .custom-control-label::before {
  position: absolute;
  top: 2px;
  left: -1.5rem;
  display: block;
  width: 15px;
  height: 15px;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}
.feedback-left-container .custom-control-label::after {
  top: 1px;
}
.fdbck-recodn-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 4px 4px;
  padding: 25px;
}
.interskilkls-head {
  font-weight: 600;
  font-size: 13px;
  color: #72738e;
  word-break: break-all;
}
.interskills-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 10px;
}
.highlighted-interskills-container {
  background: #ffffff;
  border: 2px solid #bebebe;
  border-radius: 8px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.fdbck-right-head-container {
  padding: 10px 15px;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  margin: 5px;
  background: rgba(10, 86, 200, 0.5);
  border-radius: 2px;
}
.fdbck-right-detail-container {
  background: #ffffff;
  border: 0.7px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 1px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  height: calc(100vh - 150px);
  overflow: auto;
}
.feed-heading {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}
.feedbackform-inputs {
  padding: 15px;
  background: #ffffff;
  border: 1px solid #72738e;
  box-sizing: border-box;
  border-radius: 5px;
}
.feedback-height {
  height: calc(100vh - 150px);
}
.feedback-left-container {
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  width: 50%;
}

.feedback-right-main-container {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  width: 50%;
}
.schreenshot-div {
  height: 200px;
}
.right-sub-ed {
  height: 92%;
  overflow: auto;
}
.no-skills-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}

.schreenshotdiv-file {
  opacity: 0;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
<style scoped>
.interview-process-card .card {
  border-radius: 8px;
}
.interview-process-card-selected .card {
  border-radius: 8px;
}
.interview-process-round-text {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
.interview-process-card .card-body {
  width: 100%;
  padding: 15px;
  box-shadow: 0px 4px 8px 0px #0000002b;

  border-radius: 8px;
}
.interview-process-card-selected .card-body {
  width: 100%;
  padding: 15px;
  box-shadow: 0px 4px 8px 0px #0000002b;
  background: #e1eef7;

  border-radius: 8px;
}

.interview-process-edit-card {
  background: #ffffff;
}
.w-50px {
  width: 50px;
}
.ip-more-rounds {
  color: #eb0002;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 500;
}

.w-70 {
  width: 70%;
}

.w-30 {
  width: 30%;
}

.w-95 {
  width: 95%;
}
</style>
